import React, { useState, useEffect, useContext } from 'react';
import {
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  Grid,
  CircularProgress,
  Backdrop,
  TextField,
} from '@mui/material';
import MUIDataTable from 'mui-datatables';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';
import { Link, useNavigate } from 'react-router-dom';
import Scrollbar from 'src/components/scrollbar';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Iconify from '../../../iconify';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { toast } from 'react-hot-toast';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
// mock
const { PRIVATE_ROUTE } = API_ROUTES;

export default function AdminDailyWorkReportlist() {
  const [open, setOpen] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [dwrs, setDwrs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(null);
  const { authAxios } = useContext(FetchContext);
  const [sortEnable, setSortEnable] = useState({});
  const [searchEnable, setSearchEnable] = useState();
  const [selectedstartDate, setselectstartDate] = useState(dayjs().subtract(4, 'day').format('YYYY-MM-DD'));
  const [selectendDate, setselectendDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [isValidDate, setIsValidDate] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [grandTotaltaskHour, setGrandTotalTaskHour] = useState(0);
  const [alldwrs, setAlldwrs] = useState([]);
  const [editableDwrs, setEditableDwrs] = useState([]);

  const navigate = useNavigate();

  const handleEditRedirect = (e, id) => {
    navigate(`/dwr/update/${id}`);
  };
  useEffect(() => {
    getDwrdata({
      sortField: sortEnable.sortField,
      sortOrder: sortEnable.sortOrder,
      searchQuery: searchEnable,
      page_no: page,
    });
  }, []);
  const handleRowDelete = async (e, id) => {
    if (confirm('Are you sure want to delete?') === true) {
      await authAxios.post(`${PRIVATE_ROUTE?.DELETE_DWR}${id}`);
      getDwrdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
      });
      setOpen(null);
      setSelectedRow(null);
    }
  };
  const getDwrdata = (query) => {
    setGrandTotalTaskHour(0);
    setLoading(true);
    let sort_params;
    let page_cout = query.page_no ? query.page_no : 0;
    let start_date = selectedstartDate !== null ? selectedstartDate : '';
    let end_date = selectendDate !== null ? selectendDate : '';
    let search_query = query.searchQuery ? query.searchQuery : '';

    if (typeof query !== 'string') {
      sort_params = `&startDate=${start_date}&endDate=${end_date}&sortField=${query.sortField}&sortOrder=${query.sortOrder}&search=${search_query}`;
    } else {
      sort_params = `&search=${query}&startDate=${start_date}&endDate=${end_date}`;
    }

    let isMounted = true;
    const getDailyWorkReports = async () => {
      if (start_date && end_date) {
        const { data } = await authAxios.get(
          `${PRIVATE_ROUTE?.GET_DWR}?page=${page_cout + 1}&per_page=${rowsPerPage}${sort_params}`
        );

        if (isMounted) {
          setAlldwrs(data?.data);
          setDwrs(
            data?.data?.map((item, index) => {
              
              const manager_name = item.project_managers.map(
                (project_manager) => project_manager.first_name + ' ' + project_manager.last_name
              );
              let status = 'Pending';
              let accuracy = 0;
              if (item.status === 1) {
                const estimate_hours = item.billing_line_items?.labourCosts[0]?.estimate_hour ?? 0;
                accuracy = roundToTwo(estimate_hours / item.task_hour);
                status = 'Approved';
              }
              if (item.status === 2) {
                status = 'Rejected';
              }
              const labourCostItem = item.billing_line_items?.labourCosts?.[0];
              const labourCostName = labourCostItem?.costitem?.split(' - ')[0]?.trim();
              const labourCostUuid = labourCostItem?.uuid;

              const matchedLabourItem = item?.taskdata?.billing_line_items?.labour_item?.labour_cost_items?.find(
                (l) => {
                  if (l.uuid && labourCostUuid) {
                    return l.uuid === labourCostUuid;
                  }
                  return l.costItem === labourCostName;
                }
              );

              const estimatedHours = parseFloat(matchedLabourItem?.estimated_hour || 0);

              const totalUsedHours = (item.allDwrForTask || [])
                .filter((dwr) => {
                  const dwrLabour = dwr.billing_line_items?.labourCosts?.[0];
                  if (!dwrLabour) return false;

                  if (dwr.task_id !== item.task_id) return false;

                  if (dwr.status !== 1) return false;

                  if (labourCostUuid && dwrLabour.uuid) {
                    return dwrLabour.uuid === labourCostUuid;
                  }

                  const dwrCostName = dwrLabour.costitem?.split(' - ')[0]?.trim();
                  return dwrCostName === labourCostName;
                })
                .reduce((sum, dwr) => {
                  const dwrLabour = dwr.billing_line_items?.labourCosts?.[0];
                  const usedHour = parseFloat(dwr.task_hour || dwrLabour?.estimate_hour || 0);
                  return sum + usedHour;
                }, 0);

              const pendingDwrHours = Math.max(0, estimatedHours - totalUsedHours);
              let managerEstimatedHours = 0;

              if (item.status === 1) {
                managerEstimatedHours = parseFloat(labourCostItem?.estimate_hour || 0);
              } else {
                managerEstimatedHours =
                  matchedLabourItem?.trip === true
                    ? matchedLabourItem?.estimated_hour
                    : pendingDwrHours >= item?.task_hour
                    ? item?.task_hour
                    : pendingDwrHours;
              }
              
              // ✅ Get the first labour cost item from billing line items
              // const labourCostItem = item.billing_line_items?.labourCosts?.[0];
              // const labourCostName = labourCostItem?.costitem?.split(' - ')[0]?.trim();
              // const labourCostUuid = labourCostItem?.uuid;

              // ✅ Find the matching labour cost item
              // const matchedLabourItem = item?.taskdata?.billing_line_items?.labour_item?.labour_cost_items?.find(
              //   (l) => {
              //     if (l.uuid && labourCostUuid) {
              //       return l.uuid === labourCostUuid;
              //     }
              //     return l.costItem === labourCostName;
              //   }
              // );

              // ✅ Directly assign managerEstimatedHours (no calculations)
              // let managerEstimatedHours = 0;
              // if (matchedLabourItem) {
              //   managerEstimatedHours = parseFloat(matchedLabourItem?.estimated_hour || 0);
              // }

              return {
                _id: item._id,
                dwr_number: (
                  <Link to={`/dwr/view/${item._id}`}>
                    <b>{item?.dwr_number}</b>
                  </Link>
                ),
                task_number: item.taskdata.number_str,
                job_number: item.job_number,
                project_manager: manager_name.join(', '),
                accuracy: status === 'Approved' ? accuracy + '%' : '-',
                task_hour: item?.task_hour,
                end_date: item?.end_date,
                remark: item?.remark,
                status: status,
                user_firstname: item?.user_firstname + ' ' + item?.user_lastname,
                task_date: new Date(item?.task_date).toISOString().split('T')[0],
                cost_item: item?.billing_line_items?.labourCosts[0]?.costitem,
                taskIsComplate: item?.taskdata?.is_completed,
                task_id: item?.task_id,
                cost_name: item?.billing_line_items?.labourCosts[0]?.costitem,
                dwrHour: item?.task_hour,
                pending_dwr_hours: managerEstimatedHours,
                managerEstimatedHours: managerEstimatedHours,
              };
            })
          );
          setCount(data.total);
          setLoading(false);
        }
      } else {
        setLoading(false);
        toast.error('Please select date range', { duration: 5000 });
      }
    };

    getDailyWorkReports().catch((err) => {
      if (!isMounted) return;
      console.error('failed to fetch data', err);
      setLoading(false);
    });
    return () => {
      isMounted = false;
    };
  };

  function handleDateSort() {
    if (selectendDate !== null && selectedstartDate !== null) {
      getDwrdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
      });
    }
  }
  function handleClearDateSort(selectedstartDate, selectendDate) {
    if (selectedstartDate !== null && selectendDate === null) {
      setIsValid(false);
    } else if (selectedstartDate == null && selectendDate !== null) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }
    setselectendDate(null);
    setselectstartDate(null);
  }

  useEffect(() => {
    if (isValid) {
      getDwrdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
      });
    }
    setIsValid(false);
  }, [isValid]);



  const columns = [
    {
      name: '_id',
      label: 'Name',
      options: {
        draggable: true,
        sort: false,
        filter: false,
        display: false,
      },
    },
    {
      name: 'dwr_number',
      label: 'DWR Number',
      options: {
        draggable: true,
        sort: true,
        filter: true,
        display: true,
      },
    },
    {
      name: 'task_date',
      label: 'Date',
      options: {
        draggable: true,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'task_number',
      label: 'Task Number',
      options: {
        draggable: true,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: `job_number`,
      label: 'Job Number',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: `user_firstname`,
      label: 'Employee Name',
      options: {
        draggable: false,
        sort: true,
        filter: true,
        display: true,
      },
    },
    {
      name: 'project_manager',
      label: 'Project Manager',
      options: {
        draggable: false,
        sort: true,
        filter: true,
        display: true,
      },
    },
    {
      name: 'cost_item',
      label: 'Cost Item',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'task_hour',
      label: 'Dwr Hour',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
        customBodyRender: (value, tableMeta) => {
          const color = tableMeta.rowData[9] === 'Approved' ? 'green' : '#212B36';
          const fontWeight = tableMeta.rowData[9] === 'Approved' ? 'bold' : 'normal';
          return <span style={{ color, fontWeight }}>{value}</span>;
        },
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        draggable: false,
        sort: true,
        filter: true,
        display: true,
      },
    },
    {
      name: 'accuracy',
      label: 'Accuracy',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'remark',
      label: 'Remark',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: false,
      },
    },
    {
      name: 'taskIsComplate',
      label: 'Task Status',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: false,
      },
    },
    {
      name: 'task_id',
      label: 'Task id',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: false,
      },
    },
    {
      name: 'cost_name',
      label: 'cost name',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: false,
      },
    },
    {
      name: 'dwrHour',
      label: 'dwrHour',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: false,
      },
    },
    {
      name: 'pending_dwr_hours',
      label: 'Pending DWR Hours',
      options: {
        draggable: false,
        sort: true,
        filter: true,
        display: false,
        customBodyRender: (value) => <span>{value}</span>,
      },
    },
    {
      name: 'managerEstimatedHours',
      label: 'Manager Estimated Hours',
      options: {
        customBodyRender: (value, tableMeta) => {
          const rowIndex = tableMeta.rowIndex;
          const rowData = tableMeta.rowData;

          const status = rowData[9];
          const isApproved = status === 'Approved';

          return (
            <TextField
              variant="outlined"
              size="small"
              type="number"
              disabled={isApproved}
              InputProps={{
                readOnly: isApproved,
              }}
              inputProps={{
                min: 0,
                step: '0.01',
                onKeyDown: (e) => {
                  if (['e', 'E', '+', '-'].includes(e.key)) {
                    e.preventDefault();
                  }
                },
              }}
              value={editableDwrs[rowIndex]?.managerEstimatedHours || '0'}
              onChange={(e) => {
                if (isApproved) return; // ❌ hard stop

                let newValue = e.target.value;

                if (newValue < 0) newValue = 0;
                if (!/^\d*\.?\d*$/.test(newValue)) return;

                setEditableDwrs((prev) => {
                  const updated = [...prev];
                  updated[rowIndex].managerEstimatedHours = newValue;
                  return updated;
                });
              }}
              style={{
                width: '80px',
                pointerEvents: isApproved ? 'none' : 'auto', // ✅ no interaction
                backgroundColor: isApproved ? '#f5f5f5' : 'white',
              }}
            />
          );
        },
      },
    },
    {
      name: 'Action',
      lable: 'Action',
      options: {
        filter: false,
        sort: false,
        display: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', gap: '5px' }}>
              <EditIcon
                color={tableMeta.rowData[12] === 0 ? 'inherit' : 'disabled'}
                onClick={tableMeta.rowData[12] === 0 ? (e) => handleEditRedirect(e, tableMeta.rowData[0]) : undefined}
              />
              <DeleteIcon
                color={tableMeta.rowData[9] === 'Pending' ? 'inherit' : 'disabled'}
                onClick={
                  tableMeta.rowData[9] === 'Pending' ? (e) => handleRowDelete(e, tableMeta.rowData[0]) : undefined
                }
              />
            </div>
          );
        },
      },
    },
  ];
  function roundToTwo(num) {
    return +(Math.round(num * 100 + 'e+2') + 'e-2');
  }

  useEffect(() => {
    setEditableDwrs(dwrs);
  }, [dwrs]);

  const options = {
    tableId: 'HelloWorld',
    rowHover: false,
    jumpToPage: true,
    responsive: 'standard',
    print: true,
    fixedHeader: true,
    searchOpen: true,
    filter: false,
    count: count,
    selectableRows: 'multiple',
    pagination: false,
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
      },
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      const formattedData = data.map((item) => {
        if (typeof item === 'string') return item;
  
        if (typeof item === 'object' && Array.isArray(item.data)) {
          const result = [];
  
          item.data.forEach((el) => {
            if (typeof el !== 'object') {
              result.push(el);
            } else if (el.props?.to) {
              result.push(el.props.children.props.children);
            } else if (Array.isArray(el.props?.children)) {
              const childrenArray = el.props.children;
              const combinedString = `${childrenArray[1]}, ${childrenArray[5]}, ${childrenArray[9]}, ${childrenArray[13]}`;
              result.push(combinedString);
            }
          });
          return result;
        }
        return null;
      });
  
      const result = formattedData.map((data, index) => ({
        index,
        data,
      }));
  
      const footerData = ['', '', '', '', '', '', 'Total Task Hours', `${grandTotaltaskHour}`, ''];
  
      return `${buildHead(columns)}${buildBody(result)}\n${footerData.join(',')}\n`;
    },
    // ✅ Highlight approved rows visually
    setRowProps: (row, dataIndex, rowIndex) => {
      const status = row[9];
      const isApproved = status === 'Approved';
  
      return {
        style: {
          backgroundColor: isApproved
            ? 'rgba(0, 128, 0, 0.08)'
            : rowIndex % 2 === 0
            ? 'rgba(101, 200, 208, 0.15)'
            : 'white',
          color: isApproved ? 'green' : '#212B36',
          fontWeight: isApproved ? 'bold' : 'normal',
          cursor: isApproved ? 'not-allowed' : 'pointer',
          opacity: isApproved ? 0.6 : 1,
        },
        onClick: isApproved ? (e) => e.stopPropagation() : undefined,
      };
    },

    isRowSelectable: (dataIndex) => {
      const rowData = dwrs?.[dataIndex];
      const status = rowData?.status;
      return status !== 'Approved';
    },
    setTableProps: () => ({
      border: '1px solid rgba(101, 200, 208, 0.15)',
      size: 'small',
    }),
    onSearchChange: (searchQuery) => {
      setSearchEnable(searchQuery);
      if (searchQuery && searchQuery.length > 2) {
        if (Object.keys(sortEnable).length !== 0) {
          const { sortField, sortOrder } = sortEnable;
          getDwrdata({ sortField, sortOrder, searchQuery });
        } else {
          getDwrdata({ searchQuery });
        }
      } else if (!searchQuery) {
        if (Object.keys(sortEnable).length !== 0) {
          const { sortField, sortOrder } = sortEnable;
          getDwrdata({ sortField, sortOrder });
        } else {
          getDwrdata('');
        }
      }
    },
    onChangeRowsPerPage: (numberOfRows) => setRowsPerPage(numberOfRows),
    rowsPerPage: rowsPerPage,
    serverSide: true,
    onTableChange: (action, tableState) => {
      const { name, direction } = tableState.sortOrder;
      const sortField = name;
      const sortOrder = direction;
      const searchQuery = searchEnable;
      const page_no = tableState.page;
  
      if (action === 'sort' || action === 'changePage') {
        setSortEnable({ sortField, sortOrder });
        getDwrdata({ sortField, sortOrder, searchQuery, page_no });
      }
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <div style={{ display: 'flex', gap: '10px', alignItems: 'center', padding: '5px' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={(e) => {
            const proceed = window.confirm('⚠️ Are you sure you want to approve the selected DWR(s)?');
            if (proceed) {
              handleBulkAction(e, 'Approved', selectedRows, displayData, setSelectedRows);
            } else {
              console.log('Bulk action cancelled by user');
            }
          }}
        >
          Bulk Approve
        </Button>

      </div>
    ),
  };

  const handleBulkAction = async (event, status, selectedRows, displayData, setSelectedRows) => {
    event.preventDefault();

    if (!selectedRows?.data?.length) return;

    setLoading(true);

    const selectedData = selectedRows.data.map((row) => {
      const rowIndex = row.dataIndex;
      const rowData = displayData[rowIndex]?.data;
      const index = row.dataIndex;

      return {
        dwrId: rowData[0],
        managerEstimatedHours: editableDwrs[index]?.managerEstimatedHours || 0,
      };
    });

    try {
      const response = await authAxios.post(PRIVATE_ROUTE.EDIT_BLUK_DWR_STATUS, { dwrs: selectedData });
      if (response.status === 200) {
        toast.success(response.data.message || 'Updated successfully!');
      } else {
        toast.error('Update failed!');
      }
      getDwrdata({ page_no: 0 });

      setSelectedRows([]);
    } catch (error) {
      console.error('Bulk update error:', error);
      toast.error('Something went wrong!');
    }

    setLoading(false);
  };

  return (
    <>
      <Grid sx={{ p: 4, pb: 0 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h4" gutterBottom>
            Daily Work Report
          </Typography>
          <Button
            variant="contained"
            onClick={(e) => navigate('/dwr/create')}
            startIcon={<Iconify icon="eva:plus-fill" />}
          >
            New Daily Work Report
          </Button>
        </Stack>
        <Grid container xs={8} spacing={2} sx={{ py: 2, alignItems: 'center' }}>
          <Grid item xs={12} md={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Start Date"
                inputFormat="YYYY-MM-DD"
                value={selectedstartDate}
                onChange={(value) => {
                  const formattedDate = dayjs(value).format('YYYY-MM-DD');
                  setselectstartDate(formattedDate);
                }}
                renderInput={(props) => <TextField {...props} />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="End Date"
                inputFormat="YYYY-MM-DD"
                value={selectendDate}
                onChange={(value) => {
                  const formattedDate = dayjs(value).format('YYYY-MM-DD');
                  setselectendDate(formattedDate);
                }}
                renderInput={(props) => <TextField {...props} />}
                minDate={selectedstartDate}
                onError={(newError) => setIsValidDate(newError)}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md="auto">
            <Button
              size="large"
              type="submit"
              variant="contained"
              onClick={handleDateSort}
              disabled={selectendDate === null || selectedstartDate === null}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
        <Grid>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                {loading && (
                  <div>
                    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                      <CircularProgress color="inherit" />
                    </Backdrop>
                  </div>
                )}
                <MUIDataTable data={editableDwrs} options={options} columns={columns} />

                {!dwrs && !loading && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        No Data Found
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
        </Grid>
      </Grid>
    </>
  );
}
